module.exports = __webpack_public_path__ + "img/layout-white.461fbcb3.svg";